<template>
  <page-option :title="$t('profile.persional.persionalinfo')">
    <div class="d-flex justify-center pt-md-12 pt-4">
      <v-card elevation="1" max-width="800px" width="100%">
        <v-list-item class="px-12" two-line>
          <v-list-item-avatar color="#fff" size="72">
            <svg
              fill="none"
              height="72"
              viewBox="0 0 72 72"
              width="72"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M37 0C16.576 0 0 16.576 0 37C0 57.424 16.576 74 37 74C57.424 74 74 57.424 74 37C74 16.576 57.424 0 37 0ZM37 11.1C43.142 11.1 48.1 16.058 48.1 22.2C48.1 28.342 43.142 33.3 37 33.3C30.858 33.3 25.9 28.342 25.9 22.2C25.9 16.058 30.858 11.1 37 11.1ZM37 63.64C27.75 63.64 19.573 58.904 14.8 51.726C14.911 44.363 29.6 40.33 37 40.33C44.363 40.33 59.089 44.363 59.2 51.726C54.427 58.904 46.25 63.64 37 63.64Z"
                fill="#A8A8A8"
              />
            </svg>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-h5">
              Đổi mật khẩu
            </v-list-item-title>
            <v-list-item-subtitle>
              Đổi mật khẩu của bạn
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <div>
          <div class="d-flex flex-column pa-12">
            <base-form ref="formPassword" @submit="savePassword">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <field-group no-label required>
                        <template #input="">
                          <FieldToggleShow
                            v-model="password.old_password"
                            autocomplete="current-password"
                            dense
                            :error-messages="error.old_password"
                            label="Mật khẩu hiện giờ"
                            name="current-password"
                            no-label
                            outlined
                            placeholder="********"
                            :rules="[...rules.required]"
                          />
                        </template>
                      </field-group>
                    </v-col>
                    <v-col cols="12">
                      <field-group no-label required>
                        <template #input>
                          <FieldToggleShow
                            v-model="password.password"
                            autocomplete="new-password"
                            dense
                            :error-messages="error.password"
                            :label="$t('register.newPassword')"
                            name="new-password"
                            no-label
                            outlined
                            placeholder="********"
                            :rules="[...rules.required, ...rules.password]"
                          />
                        </template>
                      </field-group>
                    </v-col>
                    <v-col cols="12">
                      <field-group no-label>
                        <template #input>
                          <FieldToggleShow
                            v-model="password.password_confirmation"
                            autocomplete="new-password"
                            dense
                            :error-messages="error.password_confirmation"
                            :label="$t('register.comfirmPassword')"
                            name="passwordcomfirm"
                            no-label
                            outlined
                            placeholder="********"
                            :rules="[
                              ...rules.required,
                              passwordConfirmationRule,
                            ]"
                          />
                        </template>
                      </field-group>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="d-flex pl-md-6">
                    <v-list-item class="full-width">
                      <v-list-item-content class="py-0">
                        <v-list-item-title class="text-pre-wrap">
                          {{ $t('passwordRule.title') }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-pre-wrap">
                          - Tối thiệu 8 kí tự
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="text-pre-wrap">
                          - Chứa ít nhất một kí tự chữ cái
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="text-pre-wrap">
                          - Chứa ít nhất một chữ số
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="text-pre-wrap">
                          - Chứa ít nhất một kí tự đặc biệt: @$!%*&?
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-col>
              </v-row>

              <div>
                <base-button color="primary" @click="savePassword()">
                  {{ $t('actions.changePassword') }}
                </base-button>
                <span class="mx-1"></span>
                <base-button color="primary" @click="resetFields()">
                  {{ $t('actions.resetAll') }}
                </base-button>
              </div>
            </base-form>
          </div>
        </div>
      </v-card>
    </div>
  </page-option>
</template>

<script>
import rules, { passwordRegex } from '@utils/rules'
import FieldToggleShow from '@components/field/field-toggle-show.vue'
import { mapGetters } from 'vuex'
export default {
  components: { FieldToggleShow },
  data: (vm) => ({
    password: {
      oldpassword: '',
      password: '',
      password_confirmation: '',
    },
    rules,
    error: {},
  }),
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
    passwordConfirmationRule() {
      const vm = this
      return () =>
        vm.password.password === vm.password.password_confirmation ||
        vm.$t('validation.notmatchpassword')
    },
  },
  methods: {
    async savePassword(e) {
      this.error = {}
      if (!(await this.$refs.formPassword.validate())) return
      let password = this.password.password
      if (password && !passwordRegex.test(password)) {
        this.$set(
          this.error,
          'password',
          'Mật khẩu cần ít nhất một chữ cái, một số và chứa kí tự đặc biệt:@$!%*&?'
        )
        return
      }
      const res = await this.$store.dispatch(
        'auth/updatePassword',
        this.password
      )
      let error = res.error
      if (error && error.response && error.response.status == 422) {
        this.error = error.response.data.errors
      }
    },
    resetFields() {
      this.password = {
        oldpassword: '',
        password: '',
        password_confirmation: '',
      }
    },
  },
}
</script>
<style scoped>
.text-pre-wrap {
  white-space: pre-wrap !important;
}
</style>
